import { PerformanceReviewDimensionValue } from '../types/v2';

export const legacyPerformanceDimensionGroup: Record<string, string> = {
  technical_execution: 'technical_quality',
  quality_of_work: 'technical_quality',
  problem_solving_revision: 'problem_solving_growth',
  project_delivery: 'delivery_communication',
  documentation_communication: 'delivery_communication',
  independence_support: 'professional_practice',
  professional_practice: 'professional_practice',
};

export const performanceDimensionLabels: Record<string, string> = {
  technical_quality: 'Technical skill and quality',
  problem_solving_growth: 'Problem-solving and growth',
  delivery_communication: 'Delivery and communication',
  professional_practice: 'Professional practice',
};

export const displayPerformanceDimension = (key: string) => {
  const groupedKey = legacyPerformanceDimensionGroup[key] || key;
  return performanceDimensionLabels[groupedKey] || key.replace(/_/g, ' ');
};

export const dedupeRepeatedParagraphs = (value?: string) => {
  const seen = new Set<string>();
  return String(value || '').split(/\n\s*\n/).map((paragraph) => paragraph.trim()).filter((paragraph) => {
    if (!paragraph) return false;
    const fingerprint = paragraph.replace(/\s+/g, ' ').toLowerCase();
    if (seen.has(fingerprint)) return false;
    seen.add(fingerprint);
    return true;
  }).join('\n\n');
};

export const mergeLegacyPerformanceDimension = (
  key: string,
  values: Record<string, PerformanceReviewDimensionValue> | undefined,
): PerformanceReviewDimensionValue | undefined => {
  if (!values) return undefined;
  const sourceKeys = [key, ...Object.entries(legacyPerformanceDimensionGroup)
    .filter(([legacyKey, groupedKey]) => groupedKey === key && legacyKey !== key)
    .map(([legacyKey]) => legacyKey)];
  const rows = sourceKeys.map((sourceKey) => values[sourceKey]).filter(Boolean);
  if (!rows.length) return undefined;
  const unique = (items: number[]) => Array.from(new Set(items));
  return {
    level: rows.find((row) => row.level)?.level || '',
    teacher_comment: dedupeRepeatedParagraphs(rows.map((row) => row.teacher_comment?.trim()).filter(Boolean).join('\n\n')),
    evidence_link_ids: unique(rows.flatMap((row) => row.evidence_link_ids || [])),
    milestone_ids: unique(rows.flatMap((row) => row.milestone_ids || [])),
    work_evidence_ids: unique(rows.flatMap((row) => row.work_evidence_ids || [])),
  };
};
